module.exports = __webpack_public_path__ + "img/scythe-bronze.4a4ae7ab.svg";